import { jsx as _jsx } from "react/jsx-runtime";
import Add from "components/Emails/Add";
import ADD_EMAILS_TEMPLATES from "mutations/emails/addEmailsTemplate";
import GET_EMAILS_TEMPLATES from "queries/emails/getEmailsTemplates";
import React from "react";
const TemplatesAdd = () => (_jsx(Add, { addMutation: ADD_EMAILS_TEMPLATES, itemName: "template", listQuery: GET_EMAILS_TEMPLATES }));
export default TemplatesAdd;
